export default __webpack_public_path__ + "static/media/ma9loub.242afbad.jpg";